import React from 'react';
import { findBigWinMatch, findFreespinsMatch, findHoldAndSpinMatch } from './helpers';

const SEARCH_TIMEOUT_MS = 5_000;

export const BigWin = (props: {
  config: any;
  reelStrips: string[][];
  rowsByReel: number[];
  reelIndexes: number[];
  mode: string;
  showFreespins?: boolean;
  onApply: (reelIndexes: number[]) => unknown;
}) => {
  const [toast, setToast] = React.useState('');

  React.useEffect(() => {
    if (!toast) { return; }
    const timeout = window.setTimeout(() => setToast(''), 3_000);
    return () => window.clearTimeout(timeout);
  }, [toast]);

  const applyMatch = (reelIndexes: number[] | undefined) => {
    if (!reelIndexes) {
      setToast("Can't find combination");
      return;
    }
    setToast('');
    props.onApply(reelIndexes);
  };

  const searchProps = () => ({
    config: props.config,
    reelStrips: props.reelStrips,
    rowsByReel: props.rowsByReel,
    fallbackReelIndexes: props.reelIndexes,
    timeoutMs: SEARCH_TIMEOUT_MS,
  });

  return (
    <div className="scenario-header-actions" aria-label={`${props.mode} reel presets`}>
      <button
        type="button"
        title="Find the highest-paying regular symbol on at least two reels"
        onClick={() => applyMatch(findBigWinMatch(searchProps())?.reelIndexes)}
      >
        Big Win
      </button>
      {props.showFreespins && <button
        type="button"
        title="Find the configured number of reels containing a visible scatter"
        onClick={() => applyMatch(findFreespinsMatch(searchProps())?.reelIndexes)}
      >
        Freespins
      </button>}
      {props.config.coinFeature && <button
        type="button"
        title="Find a visible coin combination that triggers Hold & Spin"
        onClick={() => applyMatch(findHoldAndSpinMatch(searchProps())?.reelIndexes)}
      >
        Hold &amp; Spin
      </button>}
      {toast && <div className="scenario-search-toast" role="status">{toast}</div>}
    </div>
  );
};
